import { useCallback, useRef, useEffect } from "react";

const useBatchResetManager = (setRefreshCounter, resetAll) => {
  const urlResetRef = useRef(null);
  const videoResetRef = useRef(null);

  const registerUrlReset = useCallback((resetFn) => {
    urlResetRef.current = resetFn;
  }, []);

  const registerVideoReset = useCallback((resetFn) => {
    videoResetRef.current = resetFn;
  }, []);

  const resetAllBatches = useCallback(() => {
    // Reset URL batches first
    if (urlResetRef.current) {
      urlResetRef.current();
    }

    // Reset video batches
    if (videoResetRef.current) {
      videoResetRef.current();
    }
  }, []);

  useEffect(() => {
    //if resetAll is even and greater than 0, setRefreshCounter to +1
    if (resetAll > 0 && parseInt(resetAll) % 2 === 0) {
      setRefreshCounter((prev) => prev + 1);
    }
  }, [resetAll]);

  return {
    registerUrlReset,
    registerVideoReset,
    resetAllBatches,
  };
};

export default useBatchResetManager;
